export default [
  {
    path: '/activity-20260423-main',
    component: () => import('./Page.vue'),
    meta: { title: '春日歌王', id: 27 },
  },
  {
    path: '/activity-20260423-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '春日歌王-报名页面', id: 27 },
  },
  {
    path: '/activity-20260423-rule-2',
    component: () => import('./Rule2.vue'),
    meta: { title: '春日歌王-规则说明', id: 27 },
  },
]
